import { render, staticRenderFns } from "./ActivityMessage.vue?vue&type=template&id=44d37518&scoped=true"
import script from "./ActivityMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityMessage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ActivityMessage.vue?vue&type=style&index=0&id=44d37518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d37518",
  null
  
)

export default component.exports